import React from 'react'
import PropTypes from 'prop-types'
import ServiceRow from './ServiceRow'
import { mapServiceTypeToTitle } from '../constants'
import UsageRow from './UsageRow'

const ServiceRowPhone = (props) => {
    return (
        <ServiceRow
            icon={`/images/icon-${props.item.type}.svg`}
            title={props.item.serviceType}
            subTitle={props.item.description}
            preTitle={props.item.serviceNumber}
            url={`/my-services/${props.item.type}/${props.item.id}`}
        >
            <UsageRow
                title='Billing cycle ends'
                isUnlimitedUsage={false}
                progress={props.item.billingCycleProgressPercentage}
                summaryText={props.item.nextBillingCycleStart}
                isDateField
            />
            {Object.keys(props.item.usageSummary).map(key => {
                const item = props.item.usageSummary[key]
                return (
                    <UsageRow
                        key={key}
                        itemKey={key}
                        title={item.labelText}
                        isUnlimitedUsage={item.isUnlimitedUsage}
                        progress={item.usagePercentage}
                        summaryText={item.summaryText}
                        showUnlimitedUsage={item.hasNoSpendLimit}
                    />
                )
            })}
        </ServiceRow>
    )
}

ServiceRowPhone.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        type: PropTypes.string,
        description: PropTypes.string,
        serviceNumber: PropTypes.string,
        usageSummary: PropTypes.object,
        isUnlimitedUsage: PropTypes.bool,
        hasNoSpendLimit: PropTypes.bool
    }).isRequired
}

export default ServiceRowPhone



// WEBPACK FOOTER //
// ./resources/js/components/ServiceRowPhone.js